import { render, staticRenderFns } from "./ResetPasswordPin.vue?vue&type=template&id=446517e3&"
import script from "./ResetPasswordPin.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports